import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs/esm/index';

@Pipe({
    name: 'ftDateRange',
    standalone: false
})
export class DateRangePipe implements PipeTransform {
    transform(range: [string | Date, string | Date]): string {
        console.log(range);
        if (!range?.[0]) return '';

        const [start, end] = range || [];

        const s = dayjs(start);
        const e = end ? dayjs(end) : null;

        if (!e || s.isSame(e, 'day')) {
            return s.format('MMM D, YYYY').toUpperCase();
        }

        if (s.year() === e.year()) {
            if (s.month() === e.month()) {
                // Same month + year
                return `${s.format('MMM D')}–${e.format('D, YYYY')}`.toUpperCase();
            }
            // Same year, different months
            return `${s.format('MMM D')} – ${e.format('MMM D, YYYY')}`.toUpperCase();
        }

        // Different years
        return `${s.format('MMM D, YYYY')} – ${e.format('MMM D, YYYY')}`.toUpperCase();
    }
}
